 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const CostLogiMst = props => {

    const panelsdef = [];
    const formid = getformid("CostLogiMst", props.location.search);
    const controller = getcontroller("CostLogiMst", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
    ];

    const actionurl = {
        "update": "CostLogiMst/Update",
        "getlist": "CostLogiMst/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]


    function Listlockcell(e) {
        if (e.context.status !== 'UPDATE' && !isEmpty(e.context.status)) {
            return;
        }
        if (e.colDef.colId !== "SSD_SYUDO") {
            return;
        }
        if (e.data["SSD_SYNFLG1"] === "0") {
            return false;
        }
        if (e.data["RANK"] !== "1") {
            return false;
        }
        return true;
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                suppressaction={suppressaction}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
                lockcell={Listlockcell}
           >
            </MasterBase>
        </div>
    );
};


